import { AxiosResponse } from "axios";
import { ApiResponse, Question, ScoreData } from "entities";
import axiosHttp from "utils/http.config";
import { storage } from "utils/storage";

export interface loginDto {
  username: string;
  password: string;
}

export interface createDto {
  question: string;
  date_debut: string;
  date_fin: string;
}

export interface updateDto {
  question_id: string;
  dev_id: string;
  question: string;
  date_debut: string;
  date_fin: string;
}
export class AppService {
  static processLogin(token: string, username: string): void {
    storage.set("token", token);
    storage.set("username", username);
  }

  static processLogout(): void {
    storage.remove("token");
    storage.remove("username");
  }

  static getAccessToken(): string | null {
    return storage.get<string>("token");
  }

  static getUsername(): string | null {
    return storage.get<string>("username");
  }

  static isLoggedIn(): boolean {
    return this.getAccessToken() != null && this.getUsername() != null;
  }

  static async login(body: loginDto): Promise<string> {
    const response: AxiosResponse<{ token: string; username: string }> =
      await axiosHttp.post("/login", body);
    const { token, username } = response.data;
    AppService.processLogin(token, username);
    return username;
  }

  static async listQuestion(): Promise<{
    questions: Question[];
    name: string;
  } | null> {
    try {
      const response: AxiosResponse<
        ApiResponse<{ questions: Question[]; name: string }>
      > = await axiosHttp.get("/question");
      const data = response.data;
      return data.data;
    } catch (error) {
      return null;
    }
  }

  static async listDevice(): Promise<{ dev_id: string }[] | null> {
    try {
      const response: AxiosResponse<
        ApiResponse<{ devices: { dev_id: string }[] }>
      > = await axiosHttp.get("/device");
      const data = response.data;
      return data.data.devices;
    } catch (error) {
      return null;
    }
  }

  static async listQuestionStat(
    questionId: string
  ): Promise<{ question: Question; stats: ScoreData[]; name: string } | null> {
    try {
      const response: AxiosResponse<
        ApiResponse<{ question: Question; stats: ScoreData[]; name: string }>
      > = await axiosHttp.post("/stat", { questionId });
      const data = response.data;
      return data.data;
    } catch (error) {
      return null;
    }
  }

  static async createQuestion(body: createDto): Promise<Question | null> {
    try {
      const response: AxiosResponse<ApiResponse<Question>> =
        await axiosHttp.post("/question", body);
      const data = response.data;
      return data.data;
    } catch (error) {
      return null;
    }
  }

  static async updateQuestion(body: updateDto): Promise<Question | null> {
    try {
      const response: AxiosResponse<ApiResponse<Question>> =
        await axiosHttp.patch("/question", body);
      const data = response.data;
      return data.data;
    } catch (error) {
      return null;
    }
  }

  static async deleteQuestion(body: {
    question_id: string;
    dev_id: string;
  }): Promise<{ success: boolean } | null> {
    try {
      const response: AxiosResponse<ApiResponse<{ success: boolean }>> =
        await axiosHttp.put("/question", body);
      const data = response.data;
      return data.data;
    } catch (error) {
      return null;
    }
  }
}
